import queryString from 'query-string';

export function languageUrl(url: string, language?: string): string {
  return queryString.stringifyUrl({ url, query: { lang: language } });
}
